import React, { Fragment } from 'react';
import Layout from '@components/Layout';
import styles from './styles.module.scss';
import { Grid, Divider, Col, Row } from '@components/Grid';
import Input from '@components/Input';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Card from '@components/Card';
import Alert from '@components/Alert';
import SEO from '@components/SEO';
import { graphql } from 'gatsby';
import Form from '@components/Form';

const Contact = ({ data: { form } }) => {
    return (
        <Layout>
            <SEO
                title="Contact"
                description="Contact Sylvan Arms for your Gunsmithing needs. We cater to your queries for maintenance or supplies. Give us a call we will be there like bullet speed."
            />
            <div className={styles.contactMain}>
                <Grid>
                    <Row>
                        <Col xs={12} md={6} lg={9}>
                            <Row>
                                <Col xs={12} md={6} lg={6}>
                                    <h1>CONTACT</h1>
                                </Col>
                            </Row>
                            <Divider />
                            <Row className={styles.secondHeadingMain}>
                                <Col xs={12} md={10} lg={6}>
                                    <div className={styles.secondHeading}>
                                        HAVE A QUESTION? CONTACT A SYLVAN ARMS REPRESENTATIVE
                                    </div>
                                </Col>
                            </Row>
                            <Divider margin={2} />
                            <p>
                                Email us at{' '}
                                <a href="mailto:service@sylvanarms.com" rel="noopener noreferrer">service@sylvanarms.com</a>{' '}
                                or use the form below.
                            </p>
                            <Divider />

                            <Form form={form} />
                        </Col>
                    </Row>
                </Grid>
            </div>
        </Layout>
    );
};

export default Contact;

export const query = graphql`
    query {
        form: merlinForm(_id: { eq: "5f9040835f6dd5001773da79" }) {
            _id
            name
            description
            meta {
                updatedTimestamp
            }
            sections {
                _id
                title
                description
                multiple
                min
                max
                fields {
                    label
                    hint
                    optional
                    options {
                        _id
                        label
                    }
                    validation {
                        type
                        condition
                        value
                        error
                    }
                    type
                    placeholder
                    id
                    _id
                }
            }
        }
    }
`;
